import React, { FC, useEffect, useState } from "react";
import { Routes } from "./routes/Routes";
import axios from "axios";
import { setAccessToken } from "./@vars/acessToken";
import { Loader } from "./components/UI/Loader";
import { load as loadIntercom, boot as bootIntercom } from "./config/intercom";
import { BrowserRouter } from "react-router-dom";
import { usePrefetchQuery } from "./hooks/query/usePrefetchQuery";

interface AppProps {}

export const App: FC<AppProps> = () => {
  loadIntercom();
  bootIntercom();
  const [loading, setLoading] = useState<boolean>(true);
  const prefetchQuery = usePrefetchQuery();
  useEffect(() => {
    prefetchQuery.prefetchProcessingFee();
    prefetchQuery.prefetchRate();
    const refreshToken = async () => {
      try {
        const { data } = await axios.post("/refresh_token");
        setAccessToken(data.accessToken);
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    };
    refreshToken();
  }, [prefetchQuery]);
  if (loading) {
    return <Loader />;
  }
  return (
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  );
};
